import { render, staticRenderFns } from "./tasknotify.vue?vue&type=template&id=6a739b1e&scoped=true"
import script from "./tasknotify.vue?vue&type=script&lang=js"
export * from "./tasknotify.vue?vue&type=script&lang=js"
import style0 from "./tasknotify.vue?vue&type=style&index=0&id=6a739b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a739b1e",
  null
  
)

export default component.exports